import { createBrowserRouter } from "react-router-dom";
import App from "@/App";
import {
  Login,
  Layout,
  Dashboard,
  Admins,
  CompanyStamp,
  Subscription,
  Template,
  InstallmentSetting,
  BulkEmail,
  SuperChatContent,
  SuperChatLog,
} from "@/pages";
import Router from "@/constants/router";

const router = createBrowserRouter([
  {
    path: Router.Dashboard,
    element: <App />,
    children: [
      ////////// 로그인 //////////
      {
        path: Router.Login,
        element: <Login />,
      },
      {
        path: Router.Dashboard,
        element: <Layout />,
        children: [
          ////////// 대시보드 //////////
          {
            path: Router.Dashboard,
            element: <Dashboard />,
          },
          ////////// 관리자 관리 //////////
          {
            path: Router.Admins,
            element: <Admins.List />,
          },
          {
            path: Router.AdminsCreate,
            element: <Admins.Create />,
          },
          {
            path: Router.AdminsDetail,
            element: <Admins.Detail />,
          },

          ////////// 도장 관리 //////////
          {
            path: Router.CompanyStamp,
            element: <CompanyStamp.List />,
          },
          {
            path: Router.CompanyStampDetail,
            element: <CompanyStamp.Detail />,
          },
          ////////// 구독 상품 관리 //////////
          {
            path: Router.Subscription,
            element: <Subscription.List />,
          },
          {
            path: Router.SubscriptionCreate,
            element: <Subscription.Create />,
          },
          {
            path: Router.SubscriptionDetail,
            element: <Subscription.Detail />,
          },
          ////////// 템플릿 관리 //////////
          {
            path: Router.Template,
            element: <Template.List />,
          },
          {
            path: Router.TemplateCreate,
            element: <Template.Create />,
          },
          {
            path: Router.TemplateDetail,
            element: <Template.Detail />,
          },
          ////////// 분할결제 설정 관리 //////////
          {
            path: Router.InstallmentSetting,
            element: <InstallmentSetting.List />,
          },
          {
            path: Router.InstallmentSettingCreate,
            element: <InstallmentSetting.Create />,
          },
          {
            path: Router.InstallmentSettingDetail,
            element: <InstallmentSetting.Create />,
          },
          ////////// 이메일 대량 발송 관리 //////////
          {
            path: Router.BulkEmail,
            element: <BulkEmail.List />,
          },

          ////////// QNA 챗봇 컨텐츠 관리 //////////
          {
            path: Router.SuperChatContent,
            element: <SuperChatContent.List />,
          },
          {
            path: Router.SuperChatContentDetail,
            element: <SuperChatContent.Detail />,
          },
          {
            path: Router.SuperChatContentCreateContent,
            element: <SuperChatContent.CreateContent />,
          },
          {
            path: Router.SuperChatContentCreatePrompt,
            element: <SuperChatContent.CreatePrompt />,
          },
          {
            path: Router.SuperChatPromptDetail,
            element: <SuperChatContent.PromptDetail />,
          },

          ////////// QNA 챗봇 로그 관리 //////////
          {
            path: Router.SuperChatLogDashboard,
            element: <SuperChatLog.Dashboard />,
          },
          {
            path: Router.SuperChatLogSessions,
            element: <SuperChatLog.Sessions />,
          },
          {
            path: Router.SuperChatLogSessionDetail,
            element: <SuperChatLog.SessionDetail />,
          },
        ],
      },
    ],
  },
]);

export default router;
